var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MappingInterfaceFieldHeader',{attrs:{"title":`Map a ${_vm.serviceName} connection block from ${_vm.configurationType} setup`,"allowChange":_vm.credentialSelectorFields?.length > 0},on:{"change-mapping":_vm.openChangeConnectionMappingDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }